import {
	AlertBar,
	Anchor,
	DateString,
	FormattedText,
	Typography
} from "client/Components";
import { TimeZone } from "client/DateAndTime/timezones";
import { useUserTimezone } from "client/Hooks";
import { createBrowserNavigationUrl } from "client/Navigation";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { singleSignOnSettingsRouting } from "../Settings/SsoSettings/Page";
import { OAuth2SecretKeyExpirationModel } from "client/Api/SingleSignOnSettings/singleSignOnSettings";
import { ensureNotNil } from "client/Misc/utils";
import { createRoot } from "react-dom/client";

export type OAuth2SecretKeyExpirationAlertProps = {
	date: Date | string;
};

export const OAuth2SecretKeyExpirationAlert = (props: OAuth2SecretKeyExpirationAlertProps): ReactElement => {
	const {
		date
	} = props;

	const userTimezone: TimeZone = useUserTimezone();

	return (
		<AlertBar
			kind="warning"
			isInline
			isDismissable={false}
		>
			<FormattedText
				text={localize("_TheClientSecretForSingleSignOnExpiresMessage")}
				thingsToReplace={
					[
						{
							what: "{{Date}}",
							filler: (
								<Typography weight="bold">
									<DateString
										value={date}
										format="DMY"
										timezone={userTimezone}
									/>
								</Typography>
							)
						}
					]
				}
				thingsToWrap={
					[
						{
							blockId: "ClickHere",
							wrap: (children) => (
								<Anchor
									href={createBrowserNavigationUrl(singleSignOnSettingsRouting.page)}
								>
									{children}
								</Anchor>
							)
						}
					]
				}
			/>
		</AlertBar>
	);
};
OAuth2SecretKeyExpirationAlert.displayName = "OAuth2SecretKeyExpirationAlert";

export function init(model: OAuth2SecretKeyExpirationModel): void {
	if (!model.shouldShowExpirationMessage) {
		return;
	}

	const alertBarContainer: HTMLElement = ensureNotNil(document.querySelector<HTMLElement>(".app-layout__global-alert"));

	const reactHost = document.createElement("div");

	alertBarContainer.append(reactHost);

	createRoot(
		reactHost
	)
		.render(
			<OAuth2SecretKeyExpirationAlert date={model.expirationDate} />
		);
};